import { flexRender } from '@tanstack/react-table';
import React from 'react';
import { IBillingDocumentsTable } from '../lxs-billing-documents.data';

const BillingDocumentsTableHead: React.FC<IBillingDocumentsTable> = ({ table }) => {
    return (
        <thead>
            {table.getHeaderGroups().map((headerGroup: { id: React.Key | undefined; headers: any[] }) => (
                <tr key={headerGroup.id}>
                    {headerGroup.headers.map(header => {
                        const sortValue =
                            { asc: 'msc-table-sorting--asc', desc: 'msc-table-sorting--desc' }[header.column.getIsSorted() as string] ??
                            null;
                        return (
                            <th key={header.id} colSpan={header.colSpan}>
                                {header.isPlaceholder ? null : (
                                    <>
                                        <div
                                            className={
                                                header.column.getCanSort()
                                                    ? `msc-table-sorting ${sortValue ?? 'msc-table-sorting--default'} `
                                                    : ''
                                            }
                                            onClick={header.column.getToggleSortingHandler()}
                                        >
                                            {flexRender(header.column.columnDef.header, header.getContext())}
                                        </div>
                                    </>
                                )}
                            </th>
                        );
                    })}
                </tr>
            ))}
        </thead>
    );
};

export default BillingDocumentsTableHead;
